import moment from 'moment-timezone';
import packageJson from '../../package.json';

export const appVersion = packageJson.version;
export const appBuildDate = packageJson.buildDate ? moment(packageJson.buildDate).format('DD/MM/YYYY HH:mm') : '';

export function getFrontVersionLabel() {
    return appBuildDate ? `${appVersion} - ${appBuildDate}` : appVersion;
}
